/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useState } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, EyeIcon } from "@heroicons/react/24/solid";

import { useAccountsQuery } from "../api";
import { useAuth } from "context/Auth";

function classNames(...classes: Array<String>) {
  return classes.filter(Boolean).join(" ");
}

export function AccountSwitcher() {
  const [authState, authDispatch] = useAuth();
  const [selected, setSelected] = useState(authState.activeAccount);

  const accountsQuery = useAccountsQuery();

  if (accountsQuery.loading) return <div>Loading.</div>;

  const activeAccount = accountsQuery.data?.accounts.find(
    (a) => a.account.id === authState.activeAccount
  );

  return (
    <Listbox
      value={selected}
      onChange={(e: any) => {
        setSelected(e);
        authDispatch({ type: "set_account", account: e.id });
      }}
    >
      {({ open }) => (
        <>
          <Listbox.Label className="block text-sm font-medium text-gray-300">
            Switch Accounts
          </Listbox.Label>
          <div className="mt-1 relative">
            <Listbox.Button className="bg-gray-200 relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
              <span className="block truncate">
                {activeAccount?.account.name}
              </span>
              <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                <EyeIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
              </span>
            </Listbox.Button>

            <Transition
              show={open}
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options
                static
                className="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm"
              >
                {accountsQuery?.data?.accounts.map(({ account }) => (
                  <Listbox.Option
                    key={account.id}
                    className={({ active }) =>
                      classNames(
                        active ? "text-white bg-indigo-600" : "text-gray-900",
                        "cursor-default select-none relative py-2 pl-3 pr-9"
                      )
                    }
                    value={account}
                  >
                    {({ selected, active }) => (
                      <>
                        <span
                          className={classNames(
                            selected ? "font-semibold" : "font-normal",
                            "block truncate"
                          )}
                        >
                          {account.name}
                        </span>

                        {selected ? (
                          <span
                            className={classNames(
                              active ? "text-white" : "text-indigo-600",
                              "absolute inset-y-0 right-0 flex items-center pr-4"
                            )}
                          >
                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </Transition>
          </div>
        </>
      )}
    </Listbox>
  );
}
